import React, { useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";

export default function Login() {
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Modal state
  const [modal, setModal] = useState({
    show: false,
    message: "",
    redirect: null // if not null, redirect after OK
  });

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("https://swiftexprofit.com/login", {
        email,
        password,
      });

      // Store token from backend dynamically
      if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
      }

      // Show modal with backend message
      setModal({
        show: true,
        message: res.data?.message || "Login successful",
        redirect: "/" // after clicking OK → redirect to homepage
      });

    } catch (error) {
      setModal({
        show: true,
        message: error.response?.data?.message || "Login failed",
        redirect: null // do NOT redirect on error
      });
    }
  };

  const closeModal = () => {
    setModal({ ...modal, show: false });

    // Redirect ONLY on successful login
    if (modal.redirect) {
      history.push(modal.redirect);
    }
  };

  return (
    <div className="vh-100 d-flex justify-content-center">
      {/* MODAL */}
      {modal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#1f1f1f",
              color: "#fff",
              padding: "25px",
              borderRadius: "8px",
              width: "400px",
              textAlign: "left",
              boxShadow: "0 8px 32px rgba(0,0,0,0.6)"
            }}
          >
            <h5 style={{ marginBottom: "10px" }}>Login Status</h5>
            <p style={{ marginBottom: "20px" }}>{modal.message}</p>

            <button className="btn btn-primary" onClick={closeModal}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* FORM */}
      <div className="form-access my-auto">
        <form onSubmit={handleLogin}>
          <span>Sign In</span>

          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ color: "white" }}
            />
          </div>

          <div className="text-right">
            <Link to="/reset">Forgot Password?</Link>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="form-checkbox"
            />
            <label className="custom-control-label" htmlFor="form-checkbox">
              Remember me
            </label>
          </div>

          <button type="submit" className="btn btn-primary">
            Sign In
          </button>
        </form>

        <h2>
          Don't have an account? <Link to="/signup">Sign up here</Link>
        </h2>
      </div>
    </div>
  );
}
